/**
 * Shrink header and toggle overlay menu functions
 */

const burger = document.getElementById('burger'),
      overlayMenu = document.getElementById('overlay-menu')

burger.addEventListener('click', () => {
  if (burger.classList.contains('active')) {
    burger.classList.remove('active')
    overlayMenu.classList.remove('active')
    document.body.classList.remove('no-scroll')
  } else {
    burger.classList.add('active')
    overlayMenu.classList.add('active')
    document.body.classList.add('no-scroll')
  }
})

const header = document.querySelector('.site-header')

function shrinkHeader() {
  if (window.scrollY > 300) {
    header.classList.add('shrinked')
    overlayMenu.classList.add('navbar-shrinked')
  } else {
    header.classList.remove('shrinked')
    overlayMenu.classList.remove('navbar-shrinked')
  }
}

shrinkHeader()

window.addEventListener('scroll', () => {
  shrinkHeader()
})

/**
 * Header tooltips
 */

const tooltipToggles = document.querySelectorAll('.top-bar .tooltip-toggle')

var tooltipOpen = false

tooltipToggles.forEach(tooltipToggle => {
  tooltipToggle.addEventListener('mouseenter', function() {
    // close other tooltips except current one
    closeTooltips(tooltipToggle)
    // toggle current tooltip
    this.classList.add('active')
    document.body.classList.add('no-scroll')
    tooltipOpen = !tooltipOpen
  })
  tooltipToggle.addEventListener('mouseleave', function() {
    this.classList.remove('active')
    document.body.classList.remove('no-scroll')
    tooltipOpen = !tooltipOpen
  })
})

function closeTooltips(current = null) {
  tooltipToggles.forEach(tooltipToggle => {
    if (tooltipToggle === current) return
    if (!tooltipToggle.classList.contains('active')) return
    tooltipToggle.classList.remove('active')
    tooltipOpen = false
    document.body.classList.remove('no-scroll')
  })
}

// close all tooltips on outside click
document.addEventListener('click', (event) => {
  if (event.target.closest('.tooltip')) return
  if (event.target.closest('.tooltip-toggle')) return
  if (!tooltipOpen) return
  closeTooltips()
})

// close all tooltips when escape key is pressed
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' && tooltipOpen) closeTooltips()
})

/**
 * Back to top button
 */

const backtoTop = document.getElementById('back-to-top')

function showBackToTop() {
  if (window.scrollY >= 600) {
    backtoTop.classList.add('active')
  } else {
    backtoTop.classList.remove('active')
  }
}

showBackToTop()

window.addEventListener('scroll', () => {
  showBackToTop()
})

backtoTop.addEventListener('click', function(event) {
  event.preventDefault()
  document.body.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
})

/**
* Animation intersection observer
*/
const animationElements = document.querySelectorAll('.animation')

const animationObserver = new IntersectionObserver (animationObserverCallback, {
  root: null,
  rootMargin: '0px',
  threshold: 0.125,
})

function animationObserverCallback(entries, animationObserver) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('triggered')
      animationObserver.unobserve(entry.target)
    }
  })
}

if (animationElements !== null) {
  animationElements.forEach(el => {
    animationObserver.observe(el)
  })
}

/**
 * Contact form
 */

const contactForm = document.getElementById('contact-form')

if (contactForm !== null) {

  contactForm.addEventListener('submit', function(event) {
    event.preventDefault()

    const messageContainer = this.querySelector('.message')
    const submitButton = this.querySelector('button[type="submit"]')

    // convert form fields to a FormData object
    const data = new FormData(this)

    // append action and nonce
    data.append('action', 'send_contact_form')
    data.append('nonce', contactFormAjax.nonce)

    fetch(contactFormAjax.url, {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Something went wrong');
      }
    })
    .then((data) => {
      let color = 'text-green-500'
      if (data.error) {
        color = 'text-primary'
      } else {
        // disable submit button if there was no error
        submitButton.disabled = true
      }
      if (data.message) {
        // reset message container
        messageContainer.innerHTML = ''
        // fill message container
        messageContainer.insertAdjacentHTML('afterbegin', '<span class="'+color+'">'+data.message+'</span>')
        // wait 500ms before fading it in
        setTimeout(() => {
          messageContainer.classList.add('active')  
        }, 500)
      }
    })
    // catch server errors etc.
    .catch((error) => console.error(error))
  })

}